export default __webpack_public_path__ + "static/team1-61718ea9ddf4b0ebc46df50d4b243d60.jpg";